import { comments } from '@/mocks/siteData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            读者热议
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">吃瓜群众火力全开，看看大家都在聊什么</p>
        </div>

        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-50 border border-background-200/60 rounded-xl p-4 md:p-5">
              <div className="flex items-start gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 md:w-11 md:h-11 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-medium text-sm text-foreground-900">{comment.name}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      comment.tag === '业内人士' ? 'bg-primary-100 text-primary-700' :
                      comment.tag === '内部人士' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {comment.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed mt-2">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}